import { DecisionConstants } from './decision.constants';
import { DecisionInterface, DecisionResponseInterfaceAll, DecisionResponseInterfaceSingle, ReducerActionInterface } from '../../interfaces';

// ============ INTERFACE ============

export interface DecisionStateInterface {
  currentDecision?: DecisionInterface;
  decisions?: DecisionResponseInterfaceAll;
  error?: string;
}

// ============ INIT STATE ============

const initialState: DecisionStateInterface = {
  currentDecision: undefined,
  decisions: {
    data: [],
    meta: {
      totalResourceCount: 0
    }
  }
}

// ============ REDUCERS ============

const getSingleSuccess = (state: DecisionStateInterface, payload: DecisionResponseInterfaceSingle): DecisionStateInterface => {
  return {
    ...state,
    currentDecision: payload.data,
  };
};

const getAllSuccess = (state: DecisionStateInterface, payload: DecisionResponseInterfaceAll): DecisionStateInterface => {
  return {
    ...state,
    decisions: {
      data: payload.data,
      meta: payload.meta
    }
  };
};

const createSuccess = (state: DecisionStateInterface, payload: DecisionResponseInterfaceSingle): DecisionStateInterface => {
  return {
    ...state,
    currentDecision: payload.data,
  };
};

const updateSuccess = (state: DecisionStateInterface, payload: DecisionResponseInterfaceSingle): DecisionStateInterface => {
  return {
    ...state,
    currentDecision: payload.data,
  };
};

const clearCurrent = (state: DecisionStateInterface): DecisionStateInterface => {
  return {
    ...state,
    currentDecision: undefined,
  };
};

const clearList = (state: DecisionStateInterface): DecisionStateInterface => {
  return {
    ...state,
    decisions: {
      data: [],
      meta: {
        totalResourceCount: 0
      }
    }
  };
};

const deleteSuccess = (state: DecisionStateInterface): DecisionStateInterface => {
  return {
    ...state,
    currentDecision: undefined,
  };
};

const error = (state: DecisionStateInterface, payload: string) => {
  return {
    ...state,
    error: payload,
  };
};

// ============ EXPORTS ============

export const DecisionReducer = (state = initialState, action: ReducerActionInterface) => {
  switch (action.type) {
    case DecisionConstants.GET_SINGLE_SUCCESS:
      return getSingleSuccess(state, action.payload);
    case DecisionConstants.GET_ALL_SUCCESS:
      return getAllSuccess(state, action.payload);
    case DecisionConstants.CREATE_SUCCESS:
      return createSuccess(state, action.payload);
    case DecisionConstants.UPDATE_SUCCESS:
      return updateSuccess(state, action.payload);
    case DecisionConstants.CLEAR_CURRENT:
      return clearCurrent(state);
    case DecisionConstants.CLEAR_LIST:
      return clearList(state);
    case DecisionConstants.DELETE:
      return deleteSuccess(state);
    case DecisionConstants.ERROR:
      return error(state, action.payload);
    default:
      return state;
  }
};
